// extracted by mini-css-extract-plugin
export default {"menu__logo":"menu__logo--1A78s","menu__logo--isotype":"menu__logo--isotype--1bdth","menu__body":"menu__body--3hUmd","menu__body--christmas":"menu__body--christmas--ygsi-","menu__content":"menu__content--X4LSl","menu__section__header":"menu__section__header--SR9ty"};
    if(module.hot) {
      // 1747648152383
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  